import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'

import colors from 'components/utils/colors'
import CardsList from './CardsList'

import Userbox from 'components/Shared/Userbox/Index'

const StyledWrapper = styled.div`
  display: flex;
  height: ${props => props.noUpperStyle ? '48px' : '96px'};
  justify-content: space-between;
  position: relative;
  border-bottom: 1px solid ${colors.secondary70};
  ${props => !props.noPadding && css`
    padding: 0 40px;
  `}
  ${props => props.noUpperStyle && css`
    padding-top: 20px;
  `}
`

const CardsListPanel = ({ onSelect, cards, selectedCardId, noPadding, withUserbox, noUpperStyle }) => {
  return (
    <StyledWrapper
      noPadding={noPadding}
      noUpperStyle={noUpperStyle}
      data-test='cards-list-panel'
    >
      <CardsList
        onSelect={onSelect}
        cards={cards}
        selectedCardId={selectedCardId}
        noUpperStyle={noUpperStyle}
      />
      {withUserbox && (<Userbox />)}
    </StyledWrapper>
  )
}

CardsListPanel.propTypes = {
  onSelect: PropTypes.func.isRequired,
  cards: PropTypes.array.isRequired,
  selectedCardId: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
  noPadding: PropTypes.bool,
  withUserbox: PropTypes.bool,
  noUpperStyle: PropTypes.bool,
}

export default CardsListPanel
